import { useEffect, useState } from 'react';

/**
 * Segundos que quedan hasta una fecha (la plaza guardada de una página de pago, G39: 30 minutos), al segundo. 0 cuando
 * ya ha pasado; null sin fecha. `ahora` se puede cambiar en las pruebas.
 */
export function useCuentaAtras(hasta: string | null | undefined, ahora: () => number = Date.now): number | null {
    const fin = hasta == null ? Number.NaN : Date.parse(hasta);
    const [, setTic] = useState(0);
    useEffect(() => {
        if (Number.isNaN(fin)) {
            return;
        }
        const reloj = setInterval(() => {
            setTic((t) => t + 1);
        }, 1000);
        return () => {
            clearInterval(reloj);
        };
    }, [fin]);
    return Number.isNaN(fin) ? null : Math.max(0, Math.round((fin - ahora()) / 1000));
}

/** «27:30» (minutos y segundos). */
export function minutosYSegundos(segundos: number): string {
    return `${String(Math.floor(segundos / 60)).padStart(2, '0')}:${String(segundos % 60).padStart(2, '0')}`;
}
